import React from "react";
import Slider from "../components/Slidbar/Slidbar";
import Tabel from "../components/Feedback/Tabel";

export const Feedback = () => {
  return (
    <>
      <Slider />
      <Tabel />
    </>
  );
};
